/* eslint-disable max-len */
export const survey = {
  questionnaire: 'Сауалнама',
  survey: 'Сауалдау',
  question: 'Сұрақ',
  'survey-finished': 'Сауалнама аяқталды. Рақмет!',
  'answers-successfuly-sent': 'Сауалнама аяқталды. Рақмет!',
  'to-next-stage': 'Келесі кезеңге өту',
  'nth-question-from-x': '{total} ішінен {current} сұрақ',
  'response-time': 'Жауапқа берілетін уақыт',
  'finish-questionnaire': 'Сауалнаманы аяқтау',
  'next-question': 'Келесі сұрақ',
  'video-interview': 'Видеосұхбат',
  'selection-stages': 'Іріктеу кезеңдері',
  'start-interview-notice': 'Видеосұхбаттан өту үшін сұрақтарға жауап жазу керек. Сұрақтар мәтін форматында немесе видео форматында қойылуы мүмкін. Жазба жасау үшін Сізге камерасы мен микрофоны бар компьютер, смартфон немесе планшет қажет болады.',
};
